<template>
    <v-container fluid>
        <v-card
            class="ma-8"
        >
            <v-card-text>
                <p class="display-1 text--primary">
                    Access Denied
                </p>
                <p>You do not have the required access to see this page.</p>
                <div class="text--primary">
                    If you believe you should not see this message, please contact an Administrator.
                </div>
            </v-card-text>
            <v-card-actions>
            <v-btn
                text
                color="teal accent-4"
                @click="$router.go(-1)"
            >
                Go back
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>